const LogoFull = () => {
  return (
    <img
      width="auto"
      height="12px"
      alt="daimler-logo"
      src="/daimler-truck-one-line-white.svg"
      style={{ marginLeft: '27px' }}
    />
  );
};

export default LogoFull;
